import React from 'react';
import './Title.css'

interface TitleProps {
  title: string
}

const smallWords = [
  'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'nor', 'of',
  'on', 'or', 'per', 'the', 'to', 'vs', 'via', 'with'
];

function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      if (smallWords.includes(word) && index !== 0) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

const Title: React.FC<TitleProps> = ({ title }) => {
  return (
    <h1>
      {toTitleCase(title)}
    </h1>
  );
};

export default Title;
